// extracted by mini-css-extract-plugin
export default {"multiSelectCrumbs":"o3-z"};